import { render, staticRenderFns } from "./NewItemSubmissionsComponent.vue?vue&type=template&id=6672b6d6&scoped=true&"
import script from "./NewItemSubmissionsComponent.vue?vue&type=script&lang=js&"
export * from "./NewItemSubmissionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672b6d6",
  null
  
)

export default component.exports